
import { M4_UNIT_1 } from './Unit1';
import { M4_UNIT_2 } from './Unit2';
import { M4_UNIT_3 } from './Unit3';  
import { M4_UNIT_4 } from './Unit4';  
import { M4_UNIT_5 } from './Unit5';
import { M4_UNIT_6 }from './Unit6';
import { M4_UNIT_7 }from './Unit7';
import { M4_UNIT_8 }from './Unit8';
import { M4_UNIT_9 }from './Unit9';
import { M4_UNIT_10 } from './Unit10';
import { M4_UNIT_11 } from './Unit11';
import { M4_UNIT_12 } from './Unit12';
import { M4_UNIT_13 } from './Unit13';
import { M4_UNIT_14 } from './Unit14';
import { M4_UNIT_15 } from './Unit15';
import { M4_UNIT_16 } from './Unit16';
import { M4_UNIT_17 } from './Unit17';
import { M4_UNIT_18 } from './Unit18';
import { M4_READING_PRACTICE } from './ReadingPractice';
import { M4_MODULE_REVIEW } from './UnitReview';

export const MODULE_4_UNITS = [
  M4_UNIT_1,
  M4_UNIT_2,    
  M4_UNIT_3,
  M4_UNIT_4,
  M4_UNIT_5,
  M4_UNIT_6,
  M4_UNIT_7,
  M4_UNIT_8,
  M4_UNIT_9,
  M4_UNIT_10,
  M4_UNIT_11,
  M4_UNIT_12,
  M4_UNIT_13,
  M4_UNIT_14,
  M4_UNIT_15,
  M4_UNIT_16,
  M4_UNIT_17,
  M4_UNIT_18,
  M4_READING_PRACTICE,
  M4_MODULE_REVIEW,
];